import { TextBodyStyled } from './TextBody.styles';
import React from 'react';

interface Props {
  width?: string;
  children?: React.ReactNode;
}

export const TextBody = (props: Props) => <TextBodyStyled {...props} />;
